import { render, staticRenderFns } from "./listCard.vue?vue&type=template&id=36d63e50&scoped=true"
import script from "./listCard.vue?vue&type=script&lang=js"
export * from "./listCard.vue?vue&type=script&lang=js"
import style0 from "./listCard.vue?vue&type=style&index=0&id=36d63e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d63e50",
  null
  
)

export default component.exports